import { compose } from "redux";
import classNames from "classnames";
import React, { PureComponent } from "react";
import { Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import CalendarWeekNumber from "app/components/CalendarYear/CalendarWeekNumber";
import WorkScheduleReportItem from "features/planner/report/workSchedule/components/WorkScheduleReportItem";
import WorkScheduleReportWeekPreview from "features/planner/report/workSchedule/components/WorkScheduleReportWeekPreview";
import WorkScheduleMonthReportHeaderDay from "features/planner/report/workSchedule/components/month/WorkScheduleMonthReportHeaderDay";

class WorkScheduleYearReportHeaderWeek extends PureComponent {
  renderPreviewDay = (day, index) => {
    const { classes } = this.props;

    return (
      <WorkScheduleMonthReportHeaderDay
        date={day}
        key={index}
        classes={{
          root: classes.previewDay,
        }}
      />
    );
  };

  render() {
    const { date, classes } = this.props;

    return (
      <WorkScheduleReportItem
        classes={{
          root: classes.root,
        }}
        title={
          <WorkScheduleReportWeekPreview
            date={date}
            renderPreviewDay={this.renderPreviewDay}
          />
        }
      >
        <Grid
          item
          container
          justifyContent="center"
          alignItems="center"
          className={classNames(classes.dateWeekContainer, {
            [classes.dateWeekContainerToday]: date.isSame(undefined, "isoWeek"),
          })}
        >
          <CalendarWeekNumber date={date} />
        </Grid>
        <Typography variant="caption" className={classes.dateDay}>
          {date.startOf("isoWeek").date()}
        </Typography>
      </WorkScheduleReportItem>
    );
  }
}

const styles = theme => ({
  root: {
    background: theme.palette.grey[50],
    height: theme.altus.mediumRow.height,
    "&:hover": {
      background: theme.altus.calendar.workdayOffColor.hover,
    },
  },
  dateWeekContainerToday: {
    background: theme.altus.calendar.contrastColor,
    "& .CalendarWeekNumber": {
      color: theme.palette.primary.contrastText,
    },
  },
  dateWeekContainer: {
    left: "50%",
    borderRadius: "50%",
    position: "absolute",
    top: theme.spacing(0.25),
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    padding: theme.spacing(0.25),
    transform: "translateX(-50%)",
    zIndex: theme.zIndex.calendarWeek,
  },
  dateDay: {
    fontSize: "0.7rem",
    lineHeight: "0.7rem",
    fontWeight: theme.typography.fontWeightBold,
    position: "absolute",
    left: "50%",
    bottom: theme.spacing(0.25),
    transform: "translateX(-50%)",
    color: theme.palette.text.secondary,
  },
  previewDay: {
    position: "relative",
    width: theme.altus.mediumRow.height,
    height: theme.altus.mediumRow.height,
    borderTop: theme.altus.workScheduleReport.defaultBorder,
    borderLeft: theme.altus.workScheduleReport.defaultBorder,
    borderBottom: theme.altus.workScheduleReport.defaultBorder,
    "&:last-of-type": {
      borderRight: theme.altus.workScheduleReport.defaultBorder,
    },
  },
  dateDayName: {
    fontSize: "0.5rem",
  },
  noWorkDay: {
    borderLeft: "none",
    background: theme.palette.grey[50],
  },
});

export default compose(withStyles(styles))(WorkScheduleYearReportHeaderWeek);
